import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import VariantService from "services/VariantService";

// Initial state for variants slice
const initialState = {
  loading: false,
  options: [],
  optionValues: [],
  successMessage: "",
  errorMessage: "",
};

export const getOptionValues = createAsyncThunk(
  "variants/getOptionValues",
  async ({ languageId }, { rejectWithValue }) => {
    try {
      const response = await VariantService.getOptionValues(languageId);
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error fetching option values");
    }
  }
);

export const createOptionValue = createAsyncThunk(
  "variants/createOptionValue",
  async (optionValue, { rejectWithValue, dispatch }) => {
    try {
      const response = await VariantService.createOptionValue(optionValue);
      dispatch(getOptionValues({ languageId: 1 }));
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error creating option value");
    }
  }
);

export const updateOptionValue = createAsyncThunk(
  "variants/updateOptionValue",
  async (optionValue, { rejectWithValue, dispatch }) => {
    try {
      const response = await VariantService.updateOptionValue(optionValue);
      dispatch(getOptionValues({ languageId: 1 }));
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error updating option value");
    }
  }
);

export const deleteOptionValue = createAsyncThunk(
  "variants/deleteOptionValue",

  async (optionValueId, { rejectWithValue, dispatch }) => {
    try {
      const response = await VariantService.deleteOptionValue(optionValueId);
      dispatch(getOptionValues({ languageId: 1 }));
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error deleting option value");
    }
  }
);

export const variantSlice = createSlice({
  name: "variants",
  initialState,
  reducers: {
    clearMessages: (state) => {
      state.successMessage = "";
      state.errorMessage = "";
    },
  },
  extraReducers: {
    [getOptionValues.pending]: (state) => {
      state.loading = true;
    },
    [getOptionValues.fulfilled]: (state, action) => {
      state.loading = false;
      state.optionValues = action.payload;
    },
    [getOptionValues.rejected]: (state, action) => {
      state.loading = false;
      state.errorMessage = action.payload;
    },

    [createOptionValue.pending]: (state) => {
      state.loading = true;
    },
    [createOptionValue.fulfilled]: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload;
    },
    [createOptionValue.rejected]: (state, action) => {
      state.loading = false;
      state.errorMessage = action.payload;
    },

    [updateOptionValue.pending]: (state) => {
      state.loading = true;
    },
    [updateOptionValue.fulfilled]: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload;
    },
    [updateOptionValue.rejected]: (state, action) => {
      state.loading = false;
      state.errorMessage = action.payload;
    },
    [deleteOptionValue.pending]: (state) => {
      state.loading = true;
    },
    [deleteOptionValue.fulfilled]: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload;
    },
    [deleteOptionValue.rejected]: (state, action) => {
      state.loading = false;
      state.errorMessage = action.payload;
    },
  },
});

export const { clearMessages } = variantSlice.actions;
export default variantSlice.reducer;
